import Backbone from 'backbone'
import { CompareScorecardItemsFilterPath }
	from 'scoreboard/reports/wizard/metric-comparison/metric-comparison-path'
import Wizard from 'scoreboard/reports/wizard/reports-wizard'
import WizardInfo from 'scoreboard/reports/wizard/reports-wizard-info'
import appDisplay from 'scoreboard/components/app-display'

const CompareScorecardFilterWizardLauncher = Backbone.View.extend({

	initialize: function(opts = {}) {
		this.options = opts
	},

	render: function() {
		//data is already cloned, so no need to do it again
		let model = new Backbone.Model(this.options.data)
		let info = new WizardInfo({ model,  path: CompareScorecardItemsFilterPath })
		let wizard = new Wizard({ model: info })

		wizard.once('done', function(m){
			this.trigger('done', m.attributes)
		}.bind(this))
		appDisplay.dialog(wizard)
		return this
	}

})

export default CompareScorecardFilterWizardLauncher
CompareScorecardFilterWizardLauncher.__filename__ = 'reports/wizard/filter-meta/compare-scorecard-filter-wizard-launcher.js'
